import Link from "next/link"
import type { ReactNode } from "react"
import type { IllustrationKind } from "./illustration.tsx"
import { Illustration } from "./illustration.tsx"

type EmptyStateProps = {
  readonly action?: { readonly href: string; readonly label: string } | { readonly control: ReactNode }
  readonly description: string
  readonly illustration: IllustrationKind
  readonly title: string
}

export const EmptyState = ({ action, description, illustration, title }: EmptyStateProps) => (
  <section aria-live="polite" className="empty-state-view">
    <Illustration decorative kind={illustration} />
    <h2>{title}</h2>
    <p>{description}</p>
    {action === undefined ? null : "href" in action ? (
      <Link className="button primary" href={action.href}>
        {action.label}
      </Link>
    ) : (
      action.control
    )}
  </section>
)
